export const reduxKey = '@@pollEditPopup';
